<template>
  <div>
    <label v-if="title">{{ title }}</label>
    <ul v-if="items.length" :class="`status ${readonly ? 'disabled' : ''}`">
      <li v-for="(item, key) in items" :key="key">
        <div class="radiobox radio-style-1">
          <input
            :readonly="readonly"
            @change="change"
            :id="name + 'item-' + item.id"
            :value="item.id"
            :name="name"
            :checked="value == item.id"
            type="radio"
            class="hide"
          />
          <label :for="name + 'item-' + item.id">{{ item.title }}</label>
          <span class="radio-item">
            <svg xmlns="http://www.w3.org/2000/svg">
              <circle r="8" cx="50%" cy="50%" class="_circle-1"></circle>
              <circle r="8" cx="50%" cy="50%" class="_circle-2"></circle>
              <circle r="8" cx="50%" cy="50%" class="_circle-3"></circle>
            </svg>
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "order-status",
  props: ["name", "items", "title", "value", "readonly"],
  methods: {
    change(e) {
      setTimeout(() => {
        this.$emit("closeModal");
      }, 100);
      if (this.readonly) {
        alert("Нельзя изменить тип вопроса");

        return true;
      }
      this.$emit("input", e.target.value);
    },
  },
};
</script>

